import React from 'react';
import './ToolsSection.css';

const ToolsSection = () => {
  const tools = [
    { icon: '▶️', title: 'Tool 1', description: 'Description for tool 1' },
    { icon: '📄', title: 'Tool 2', description: 'Description for tool 2' },
    { icon: '📅', title: 'Tool 3', description: 'Description for tool 3' },
    { icon: '📊', title: 'Tool 4', description: 'Description for tool 4' },
    { icon: '🔔', title: 'Tool 5', description: 'Description for tool 5' },
    { icon: '⚡', title: 'Tool 6', description: 'Description for tool 6' }
  ];

  return (
    <section className="tools-section">
      <div className="container">
        <h2 className="section-title">Important Tools</h2>
        <div className="tools-grid">
          {tools.map((tool, index) => (
            <div key={index} className="tool-card">
              <div className="tool-icon">{tool.icon}</div>
              <h3 className="tool-title">{tool.title}</h3>
              <p className="tool-description">{tool.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolsSection;

